import type { ApiAddress } from 'api/types/ApiAddress';
import type { ApiRemoteOptions } from 'api/types/ApiRemoteOptions';
import type { I18nFn } from 'i18n/types/I18nFn';
import { getCityStateString } from 'utils/address/getCityStateString';
import { getCountryName, getUsStateName } from 'utils/internationalization';

type Args = {
  i18n: I18nFn;
  listingType: 'JOB' | 'INTERNSHIP' | 'VOLOP' | 'EVENT';
  remoteOptions: ApiRemoteOptions;
  address: ApiAddress;
};

export function getListingViewHeaderLocationSentence({
  i18n,
  listingType,
  remoteOptions,
  address,
}: Args) {
  if (listingType === 'EVENT') {
    if (remoteOptions.remoteZone) {
      return i18n('Can attend remotely');
    }

    return getCityStateString(i18n, address);
  }

  if (remoteOptions.remoteZone === 'WORLD') {
    if (listingType === 'VOLOP') {
      return i18n('Volunteer can be anywhere in the world');
    }

    return i18n('Work can be performed from anywhere in the world');
  }

  if (remoteOptions.remoteZone === 'COUNTRY') {
    if (listingType === 'VOLOP') {
      return i18n('Volunteer must be in %(location)s', {
        location: getCountryName(i18n, remoteOptions.remoteCountry ?? ''),
      });
    }

    return i18n('Work can be performed from anywhere in %(location)s', {
      location: getCountryName(i18n, remoteOptions.remoteCountry ?? ''),
    });
  }

  if (remoteOptions.remoteZone === 'STATE') {
    if (listingType === 'VOLOP') {
      return i18n('Volunteer must be in %(state)s, %(country)s', {
        state: getUsStateName(i18n, remoteOptions.remoteState ?? ''),
        country: remoteOptions.remoteCountry ?? '',
      });
    }

    return i18n('Work must be performed in %(state)s, %(country)s', {
      state: getUsStateName(i18n, remoteOptions.remoteState ?? ''),
      country: remoteOptions.remoteCountry ?? '',
    });
  }

  if (
    remoteOptions.locationType === 'ONSITE' ||
    remoteOptions.remoteZone === 'CITY'
  ) {
    if (listingType === 'VOLOP') {
      return i18n('Volunteer must be in or near %(location)s', {
        location: getCityStateString(i18n, address),
      });
    }

    return i18n('Work must be performed in or near %(location)s', {
      location: getCityStateString(i18n, address),
    });
  }
}
